import Accordion from "accordion-js";

class Accordions extends HTMLElement {
  constructor() {
      super();
  }
  
  connectedCallback() {

      const acc = new Accordion(this, {
        duration: 400,
        showMultiple: true,
        onOpen: (currElement) => {
        //  this.addHashFromAccordion(currElement);
        },
        onClose: (currElement) => {
          //this.removeHash(currElement);
        },
      });
  }

  disconnectedCallback() {
      // Add code to run when the component is removed from the DOM
  }

  attributeChangedCallback(name, oldValue, newValue) {
      // Add code to run when the component's attributes are changed
  }

}

customElements.define('nabohjaelp-accordion', Accordions);